<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>仓库管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel">
          <el-button type="primary" @click.native="addItem" v-code="51401"
            >添加{{ $route.meta.name }}</el-button
          >
          <el-table :data="list">
            <el-table-column
              prop="name"
              align="left"
              label="名称"
            ></el-table-column>
            <el-table-column
              prop="user_name"
              align="left"
              label="负责人"
            ></el-table-column>
            <!-- <el-table-column prop="address" label="地址"></el-table-column> -->
            <el-table-column
              prop="area_name"
              align="left"
              label="区域"
            ></el-table-column>
            <el-table-column
              prop="fix_base_name"
              align="left"
              label="关联基地"
            ></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click.native="editItem(scope.row, scope.$index)"
                  v-code="51401"
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <room-former
      :model="model"
      :show.sync="formerVisible"
      @created="createdCallback"
      @updated="updatedCallback"
      :fix_bases="fix_bases"
    ></room-former>
  </div>
</template>

<script>
import { stockroomList } from '@/service/getData'
import RoomFormer from './former'
import { deepClone } from '@/utils'

export default {
  components: {
    RoomFormer,
  },
  data() {
    return {
      list: [],
      model: {
        name: '',
        area: '',
        fix_base: [],
        user_id: '',
        user_name: '',
      },
      formerVisible: false,
      editIndex: -1,
    }
  },
  created() {
    this.getList()
  },
  computed: {
    fix_bases() {
      let disabled_bases = []
      this.list.map((item, index) => {
        if (
          index != this.editIndex &&
          item.fix_base &&
          item.fix_base.length > 0
        ) {
          // let b = JSON.parse(item.fix_base)
          disabled_bases = disabled_bases.concat(item.fix_base)
        }
      })

      let fix_bases = [
        { id: 0, name: '新钻头' },
        { id: 1, name: '乌审旗' },
        { id: 2, name: '辽河' },
        { id: 3, name: '海锐' },
        { id: 4, name: '青海' },
        { id: 5, name: '新疆' },
      ]

      return fix_bases.filter((f) => disabled_bases.indexOf(f.id) == -1)
    },
  },
  methods: {
    async getList() {
      let res = await stockroomList()
      if (res.status == 0) {
        this.list = res.data.list
      }
    },
    addItem() {
      this.model = {
        name: '',
        area: '',
        fix_base: [],
        user_id: '',
        user_name: '',
      }
      this.formerVisible = true
    },

    editItem(item, index) {
      this.formerVisible = true
      this.$nextTick(() => {
        this.editIndex = index
        item.user_id = item.user_id ? item.user_id : ''
        item.area = item.area ? item.area : ''
        this.model = deepClone(item)
        this.model.fix_base = this.model.fix_base || []
      })
    },

    createdCallback(data) {
      this.getList()
    },

    updatedCallback(data) {
      this.getList()
    },
  },
}
</script>